import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 10a7 7 0 1 0 14 0a7 7 0 1 0 -14 0","key":"svg-0"}],["path",{"d":"M21 21l-6 -6","key":"svg-1"}],["path",{"d":"M8 8l-2 2l2 2","key":"svg-2"}],["path",{"d":"M12 8l2 2l-2 2","key":"svg-3"}]]

const IconZoomCode = createReactComponent('outline', 'zoom-code', 'ZoomCode', __iconNode);

export default IconZoomCode;